module.exports = __webpack_public_path__ + "static/media/background-marcas-mobile.3c396592.jpg";